import { request } from '@/request'
import {
    SET_ESCALA_FUNCIONARIO
} from './types'

export const actions = {
  loadFuncionarios(store) {
    request.get('escala/listar-funcionario')
    .then(response => {
      const data = Array.isArray(response) ? response : response.data
      const payload = data.map(i => ({ ...i, ativo: false }))

      store.commit(SET_ESCALA_FUNCIONARIO, payload)
      store.commit('INITIALIZED', true)
    })
    .catch(error => console.log(error))
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/escalas/actions.js